import { getLocationPathname } from 'core/utilities';
import type { LinkProps } from '../@types';

export function isExactPathname(pathname: string, exact: LinkProps['exact']) {
  const locationPathname = getLocationPathname();

  return exact ? locationPathname === pathname : locationPathname.startsWith(pathname || '');
}
